import { Component, OnInit } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class AppComponent implements OnInit {
  routeLinks: any[] = [];
  activeLinkIndex = -1;
  menuOpened: boolean;

  constructor(
    public router: Router,
    translate: TranslateService,
    private menuService: MenuService,
    private adapter: DateAdapter<any>,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon('green-toggle', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/expand-green.svg'));
    this.matIconRegistry.addSvgIcon('toggle', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/expand-grey.svg'));
    this.matIconRegistry.addSvgIcon('landed', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/landed-with-bg.svg'));
    this.matIconRegistry.addSvgIcon('landed-selected', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/landed-with-bg-selected.svg'));
    this.matIconRegistry.addSvgIcon('not-landed', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/not-landed-with-bg.svg'));
    this.matIconRegistry.addSvgIcon('not-landed-selected', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/not-landed-with-bg-selected.svg'));
    this.matIconRegistry.addSvgIcon('single-length', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/length-with-bg.svg'));
    this.matIconRegistry.addSvgIcon('single-length-selected', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/length-with-bg-selected.svg'));
    this.matIconRegistry.addSvgIcon('back', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/back-grey.svg'));
    this.matIconRegistry.addSvgIcon('filter', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/filters-grey.svg'));
    this.matIconRegistry.addSvgIcon('filter-selected', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/filters-green.svg'));
    this.matIconRegistry.addSvgIcon('search', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/search-grey.svg'));
    this.matIconRegistry.addSvgIcon('search-selected', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/search-green.svg'));
    // this.matIconRegistry.addSvgIcon('green-search', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/search-green.svg'));
    this.matIconRegistry.addSvgIcon('sort', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/sort-black.svg'));
    this.matIconRegistry.addSvgIcon('sort2', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/sort-black2.svg'));
    // this.matIconRegistry.addSvgIcon(
    //   'clear', this.domSanitizer.bypassSecurityTrustResourceUrl('/consignment/assets/images/close-green.svg')
    // );

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en-GB');
    translate.use('en-GB'); // triggers on change language
    this.routeLinks = [
      {
        label: translate.instant('PRODUCTS_COMPONENT'),
        link: './products',
        index: 0
      },
    ];

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.routeLinks[0].label = translate.instant('PRODUCTS_COMPONENT');
      this.adapter.setLocale(event.lang);
      moment.locale(event.lang);
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe(res => {
      this.activeLinkIndex = this.routeLinks.indexOf(
        this.routeLinks.find(tab => tab.link === '.' + this.router.url)
      );
    });

    this.menuService.state.subscribe(
      (state: boolean) => {
        this.menuOpened = state;
      }
    );
  }

  onMenuClosed() {
    this.menuService.close();
  }

}
